module.exports = __webpack_public_path__ + "img/es-ct.40c54ff6.svg";